var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('DictForm',{key:_vm.formKey,attrs:{"routerBack":true,"showSaveAs":false,"dictName":_vm.dictName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }